



































































































































































































































import { Component, Vue,Prop } from "vue-property-decorator";
import moment from "moment";
import Ajax from '../../../../lib/ajax';
import Transfer from "@/store/entities/transfer";
import TransferRegion from "@/store/entities/transferRegion";
import TransferVehicle from "@/store/entities/transferVehicle";
@Component({})

export default class Update extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  startDate: string = null;
  startDateMenu: boolean = false;
  endDate: string = null;
  endDateMenu: boolean = false;
  transferRegios:TransferRegion[]=[]
  fromRegion:TransferRegion=new TransferRegion();
  toRegion:TransferRegion=new TransferRegion();

  vehicles:TransferVehicle[]=[];
  vehicle:TransferVehicle=new TransferVehicle();
  @Prop()
  transfer!: Transfer;

  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }

  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  async getRegions(){
    var response = await Ajax.get(
        '/api/services/app/Transfer/GetRegions'
      );
      this.transferRegios=response.data.result.items;;
  }
  async getVehicles(){
    var response = await Ajax.get(
        '/api/services/app/Transfer/GetTransferVehicles'
      );
      this.vehicles=response.data.result.items;;
  }
  async saveTransferAsync(){
      await Ajax.put(
        '/api/services/app/Transfer/UpdateTransfer',this.transfer
      );
      Vue.$toast.success("Kayıt Güncellendi");
      this.closeDialog();
  }
  async saveTransfer(){
    
    this.transfer.fromRegionId=this.fromRegion.id;
    this.transfer.toRegionId=this.toRegion.id;
    this.transfer.startDate=this.startDate;
    this.transfer.endDate=this.endDate;
    this.transfer.transferVehicleId=this.vehicle.id;
    this.saveTransferAsync()
    
   
  }
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

      fromItems: ["Kemer", "Havalimanı"],
      from: [],

      toItems: ["Kemer", "Havalimanı"],
      to: [],

      vehicleTypeItems: ["Vito", "Binek", "Minibüs", "Midibus"],
      vehicleType: [],

      currencyItems: ["TRY", "USD", "EUR"],
      currency: [],

    };
  }

   async created() {
    console.log("update",this.transfer);
    this.startDate=this.transfer.startDate;
    this.endDate=this.transfer.startDate;
    this.fromRegion=this.transfer.fromRegion;
    this.toRegion=this.transfer.toRegion;
    this.vehicle=this.transfer.transferVehicle;
    await this.getRegions();
    await this.getVehicles();
  }

  

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
